<template>
  <div class="hello logo-heading-stack-centered">
    <div class="logo-heading-container-centered">
      <img src="../assets/GoBeyond-footer-logo.svg" alt="Company Logo" class="main-logo-img-stacked-centered" />
      <div class="centered-content-box">
      <h1 class="main-heading main-heading-centered">Tools that support your mental wellness journey.</h1>
        <p><span class="katy-name-script">Hey, I’m Katy.</span><br>
          I make simple software tools that support the tough 
          work of caring for our mental and emotional health. Healing 
          can be hard, and these tools are designed to help. <br><br>I’m a solo 
          Software Engineer who has put a huge focus on learning how to better 
          understand and support my own mental health over the past few years. 
          While I’m not a mental health professional, the tools I build are 
          inspired by the real, everyday practices that have helped me feel better. These tools are an extension of my personal journey, 
        and I hope they can help you, too. </p>
        <router-link to="/tools" custom v-slot="{ navigate, href }">
          <button class="browse-tools-btn" :href="href" @click="navigate">Browse Tools</button>
        </router-link>
      </div>
      <div class="centered-content-box centered-content-box-centered">
        <p><span class="katy-name-script">Say Hello</span><br> Contact me at katy@gobeyonddev.com</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Pacifico&family=Quicksand:wght@300;400&display=swap');
.hello {
  padding-top: 15px;
}
.logo-heading-stack-centered {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  box-sizing: border-box;
}
.logo-heading-container-centered {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  width: 100vw;
  box-sizing: border-box;
}
.main-logo-img-stacked-centered {
  height: 225px;
  width: auto;
  max-width: 60vw;
  display: block;
  margin: 0 auto 0 auto;
  object-fit: contain;
}
.main-heading-centered {
  font-family: 'Oswald', 'Pacifico', cursive, sans-serif;
  letter-spacing: 1px;
  font-size: 1.25rem;
  font-weight: 325;
  text-shadow: 0 1px 0 #fff, 0 1.5px 0 #fff, 0 2px 4px rgba(0,0,0,0.04);
  color: #000;
  margin: 0px 0 0 0;
  white-space: normal;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
}
@media (min-width: 701px) {
  .main-heading-centered br {
    display: inline;
  }
}
@media (max-width: 700px) {
  .main-heading-centered br {
    display: none;
  }
}
.centered-content-box {
  width: 65vw;
  min-width: 320px;
  max-width: 600px;
  margin: 24px auto 0 auto;
  padding: 24px 20px;
  background: #f2f2f2;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Quicksand', 'Pacifico', cursive, sans-serif;
  font-weight: 400;
  font-size: 1.05rem;
  letter-spacing: 1px;
  color: #222;
}
.centered-content-box-centered {
  text-align: center;
}
@media (max-width: 700px) {
  .centered-content-box {
    width: 95vw;
    min-width: unset;
    max-width: 98vw;
    padding: 16px 8px;
    margin-left: 2vw;
    margin-right: 2vw;
    box-sizing: border-box;
  }
  .main-logo-img-stacked-centered {
    height: auto;
    max-width: 55vw;
    width: 55vw;
  }
}
.katy-name-script {
  font-family: 'Pacifico', cursive, sans-serif;
  font-size: 1.2em;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: #5F593F;
  white-space: nowrap;
}
.browse-tools-btn {
  margin-top: 18px;
  padding: 10px 28px;
  font-size: 1.08rem;
  font-family: 'Quicksand', 'Pacifico', cursive, sans-serif;
  font-weight: 500;
  color: #fff;
  background: #a3471a;
  border: none;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
}
.browse-tools-btn:hover {
  background: #c75c1a;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
}
</style>
